import ClearFilters from './ClearFilters.component';

export default ClearFilters;